import {
    selectOpportunityListCreating,
    selectOpportunityListUpdating,
} from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import { useSelector } from "react-redux";
import type { OpportunityListType } from "../../types";
import OpportunityListModalContainer from "./OpportunityListModalContainer";

type Props = {
    onListCreate?(listId: string): void;
};

const ListModalContainer = ({ onListCreate }: Props) => {
    const isListBeingCreated = useSelector(selectOpportunityListCreating);
    const isListBeingUpdated = useSelector(selectOpportunityListUpdating);

    function handleAddWebsitesToList(updatedList: Readonly<OpportunityListType>) {
        // void dispatch(refreshOpportunitiesResultsForStaticListThunk(updatedList.opportunityListId));
        // TODO invalidate contacts & search results queries
    }

    return (
        <OpportunityListModalContainer
            isListDataLoading={isListBeingCreated || isListBeingUpdated}
            onAddWebsites={handleAddWebsitesToList}
            onListCreate={onListCreate}
        />
    );
}

export default ListModalContainer;
